function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg027Honduras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.006,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.337,
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "182.158,183.827 189.714,207.077 214.158,207.077 194.382,221.446 201.936,244.695    182.158,230.325 162.381,244.695 169.935,221.446 150.158,207.077 174.603,207.077  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "182.158,267.305 189.714,290.556 214.158,290.556 194.382,304.924 201.936,328.173    182.158,313.804 162.381,328.173 169.935,304.924 150.158,290.556 174.603,290.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "329.842,183.827 337.397,207.077 361.842,207.077 342.065,221.446 349.619,244.695    329.842,230.325 310.064,244.695 317.618,221.446 297.842,207.077 322.286,207.077  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "329.842,267.305 337.397,290.556 361.842,290.556 342.065,304.924 349.619,328.173    329.842,313.804 310.064,328.173 317.618,304.924 297.842,290.556 322.286,290.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "256,225.566 263.555,248.816 288,248.816 268.223,263.185 275.778,286.434 256,272.065    236.222,286.434 243.777,263.185 224,248.816 248.445,248.816  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg027Honduras);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeT0iMC4wMDYiIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMS45ODkiLz4KPGc+Cgk8cmVjdCBzdHlsZT0iZmlsbDojMzM4QUYzOyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxNzAuNjYzIi8+Cgk8cmVjdCB5PSIzNDEuMzM3IiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxNzAuNjYzIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgcG9pbnRzPSIxODIuMTU4LDE4My44MjcgMTg5LjcxNCwyMDcuMDc3IDIxNC4xNTgsMjA3LjA3NyAxOTQuMzgyLDIyMS40NDYgMjAxLjkzNiwyNDQuNjk1ICAgIDE4Mi4xNTgsMjMwLjMyNSAxNjIuMzgxLDI0NC42OTUgMTY5LjkzNSwyMjEuNDQ2IDE1MC4xNTgsMjA3LjA3NyAxNzQuNjAzLDIwNy4wNzcgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHBvaW50cz0iMTgyLjE1OCwyNjcuMzA1IDE4OS43MTQsMjkwLjU1NiAyMTQuMTU4LDI5MC41NTYgMTk0LjM4MiwzMDQuOTI0IDIwMS45MzYsMzI4LjE3MyAgICAxODIuMTU4LDMxMy44MDQgMTYyLjM4MSwzMjguMTczIDE2OS45MzUsMzA0LjkyNCAxNTAuMTU4LDI5MC41NTYgMTc0LjYwMywyOTAuNTU2ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiMzMzhBRjM7IiBwb2ludHM9IjMyOS44NDIsMTgzLjgyNyAzMzcuMzk3LDIwNy4wNzcgMzYxLjg0MiwyMDcuMDc3IDM0Mi4wNjUsMjIxLjQ0NiAzNDkuNjE5LDI0NC42OTUgICAgMzI5Ljg0MiwyMzAuMzI1IDMxMC4wNjQsMjQ0LjY5NSAzMTcuNjE4LDIyMS40NDYgMjk3Ljg0MiwyMDcuMDc3IDMyMi4yODYsMjA3LjA3NyAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgcG9pbnRzPSIzMjkuODQyLDI2Ny4zMDUgMzM3LjM5NywyOTAuNTU2IDM2MS44NDIsMjkwLjU1NiAzNDIuMDY1LDMwNC45MjQgMzQ5LjYxOSwzMjguMTczICAgIDMyOS44NDIsMzEzLjgwNCAzMTAuMDY0LDMyOC4xNzMgMzE3LjYxOCwzMDQuOTI0IDI5Ny44NDIsMjkwLjU1NiAzMjIuMjg2LDI5MC41NTYgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHBvaW50cz0iMjU2LDIyNS41NjYgMjYzLjU1NSwyNDguODE2IDI4OCwyNDguODE2IDI2OC4yMjMsMjYzLjE4NSAyNzUuNzc4LDI4Ni40MzQgMjU2LDI3Mi4wNjUgICAgMjM2LjIyMiwyODYuNDM0IDI0My43NzcsMjYzLjE4NSAyMjQsMjQ4LjgxNiAyNDguNDQ1LDI0OC44MTYgICIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };